import { convertDuration } from 'duration-iso-8601';

const convertTime = (duration, fixed) => {
  const durationResult = convertDuration(duration);

  if (durationResult === null) {
    return null;
  }

  let hour = 0;
  let minute = 0;
  let second = 0;

  if (durationResult.year !== undefined) {
    hour += durationResult.year * 365 * 24;
  }

  if (durationResult.month !== undefined) {
    hour += durationResult.month * 30 * 24;
  }

  if (durationResult.day !== undefined) {
    hour += durationResult.day * 24;
  }

  if (durationResult.hour !== undefined) {
    hour += durationResult.hour;
  }

  if (durationResult.minute !== undefined) {
    minute += durationResult.minute;
  }

  if (durationResult.second !== undefined) {
    second += durationResult.second;
  }

  minute += (hour - Math.floor(hour)) * 60;
  hour = Math.floor(hour);

  while (minute >= 60) {
    hour += 1;
    minute -= 60;
  }

  second += (minute - Math.floor(minute)) * 60;
  minute = Math.floor(minute);

  while (second >= 60) {
    minute += 1;
    second -= 60;
  }

  while (minute >= 60) {
    hour += 1;
    minute -= 60;
  }


  let hms = '';

  if (hour !== 0) {
    hms += `${hour.toString()}:`;
  }
  if (minute < 10 && hour !== 0) {
    hms += `0${minute.toString()}:`;
  } else {
    hms += `${minute.toString()}:`;
  }

  second = second.toFixed(fixed + 1 || 2);

  if(fixed === 0) {
    second = second.split('.')[0] + '~';
  }

  if (second < 10) {
    hms += `0${second.toString().substring(0, second.length -1)}`;
  } else {
    hms += second.toString().substring(0, second.length - 1);
  }

  return hms;
};

export { convertTime };
